import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgRatedBad = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 40 30",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "inherit",
		fillRule: "evenodd",
		d: "M39.565.332h-7.119v21.142h7.119V.332zM.412 19.712c0 1.939 1.602 3.524 3.56 3.524h11.23l-1.691 8.052-.054.564c0 .722.303 1.392.783 1.867l1.887 1.85 11.71-11.61a3.428 3.428 0 0 0 1.05-2.485V3.856c0-1.938-1.602-3.524-3.56-3.524H9.312c-1.477 0-2.741.88-3.275 2.15L.661 14.901a3.45 3.45 0 0 0-.249 1.287v3.365l.018.018-.018.14z"
	})
});
export default SvgRatedBad;
